import React, { useContext } from 'react'
import { NoteContext } from '../contexts/NoteContext'

import styles from '../styles/components/Note.module.css'

export function Note() {
  const { notes, removeNote, editNote } = useContext(NoteContext)

  function getListItems() {
    return notes.map(note => (
      <li key={note.id}>
        {note.isEditing ? (
          <>
            <textarea
              rows='10'
              type='text'
              value={note.text}
              onChange={e => {
                note.text = e.target.value
                editNote(note)
              }}
            />
            <button
              type='button'
              className={styles.save}
              onClick={() => {
                note.isEditing = false
                editNote(note)
              }}
            >
              <svg viewBox='0 0 327 327.688' xmlns='http://www.w3.org/2000/svg'>
                <path d='m228.550781 104.230469c-1.84375-1.910157-4.367187-3.011719-7.019531-3.058594-2.648438-.035156-5.207031.96875-7.125 2.796875l-74.824219 72.09375-28.699219-27.628906c-3.980468-3.828125-10.3125-3.707032-14.140624.269531l-23.578126 24.5c-3.828124 3.980469-3.707031 10.3125.269532 14.140625l59.230468 57.011719c3.871094 3.730469 10 3.730469 13.871094 0l105.339844-101.5c3.976562-3.832031 4.09375-10.164063.261719-14.140625zm-88.957031 119.03125-45.085938-43.402344 9.707032-10.085937 28.433594 27.375c3.875 3.726562 10.003906 3.726562 13.875 0l74.5625-71.835938 9.710937 10.082031zm0 0' />
                <path d='m164.027344 0c-90.253906 0-163.683594 73.582031-163.683594 163.847656s73.421875 163.839844 163.683594 163.839844h.011718c90.253907 0 163.683594-73.582031 163.683594-163.847656s-73.433594-163.839844-163.695312-163.839844zm.003906 307.6875h-.003906c-79.226563 0-143.683594-64.613281-143.683594-143.847656 0-79.238282 64.457031-143.761719 143.695312-143.761719 79.238282 0 143.679688 64.570313 143.679688 143.808594s-64.457031 143.800781-143.6875 143.800781zm0 0' />
              </svg>
            </button>
          </>
        ) : (
          <>
            <input type='text' readOnly={true} value={note.text} />
            <button
              type='button'
              className={styles.edit}
              onClick={() => {
                note.isEditing = true
                editNote(note)
              }}
            >
              <svg
                viewBox='0 -1 401.52289 401'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0' />
                <path d='m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0' />
              </svg>
            </button>
          </>
        )}

        <button
          className={styles.delete}
          type='button'
          onClick={() => removeNote(note.id)}
        >
          <svg viewBox='-40 0 427 427.00131' xmlns='http://www.w3.org/2000/svg'>
            <path d='m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0' />
            <path d='m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0' />
            <path d='m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0' />
            <path d='m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0' />
          </svg>
        </button>
      </li>
    ))
  }

  function getNotes() {
    if (notes.length > 0) {
      return <ul className={styles.noteContainer}>{getListItems()}</ul>
    }
  }

  return <>{getNotes()}</>
}
